import { render, staticRenderFns } from "./sales-recurring-payment-gray.svg?vue&type=template&id=4f1ba148"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports